"use strict";
import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  Renderer2,
  ɵCompiler_compileModuleSync__POST_R3__,
} from "@angular/core";

import {MatDialog, MAT_DIALOG_DATA} from "@angular/material";
import {AddProjectDialogComponent} from "../../../shared/add-project-dialog/add-project-dialog.component";
import {
  AdminService,
  CommonService,
  ProjectService,
  AlertService,
  ProfileService,
  FileService,
  LeadService,
} from "../../../_services/";
import {emailList} from "../../../_helper/global";

import {AngularFireStorage} from "@angular/fire/storage";

import * as firebase from "firebase/app"; // Typescript
// import firebase from 'firebase/app'; // JS
import "firebase/functions";

import {EditProjectDialogComponent} from "../edit-project-dialog/edit-project-dialog.component";

import {AddAppointmentDialogComponent} from "../../../shared/add-appointment-dialog/add-appointment-dialog.component";
import {AddReminderDialogComponent} from "../../../shared/add-reminder-dialog/add-reminder-dialog.component";
import {AddNoteDialogComponent} from "../../../shared/add-note-dialog/add-note-dialog.component";
import {ScheduleWalkThroughDialogComponent} from "./../schedule-walk-through-dialog/schedule-walk-through-dialog.component";
import {RequestDeliveryDialogComponent} from "../request-delivery-dialog/request-delivery-dialog.component";
import {SendToProductionDialogComponent} from "../send-to-production-dialog/send-to-production-dialog.component";
import {ProjectMapFilesDialogComponent} from "../../../shared/project-map-files-dialog/project-map-files-dialog.component";

import {environment} from "../../../../environments/environment";
import {ToastrService} from "ngx-toastr";

import * as moment from "moment";
import * as XLSX from "xlsx";

import * as fileSaver from "file-saver";
import {HttpResponse} from "@angular/common/http";
import {map, finalize} from "rxjs/operators";
import {Observable, Subscription} from "rxjs";

// Algolia
import algoliasearch from "algoliasearch";

const client = algoliasearch(
  environment.algolia.appId,
  environment.algolia.adminAPIKey
);
const index = client.initIndex("projects");

@Component({
  selector: "app-project-list",
  templateUrl: "./project-list.component.html",
  styleUrls: ["./project-list.component.scss"],
})
export class ProjectListComponent implements OnInit {
  items = [];
  items2 = [];
  excelArray: any[] = [];
  fileName = "Projects.xlsx";
  errMsg;
  projectStepFieldList: any[];
  newFieldList: any[];
  projectStepList: any[];
  successMsg;
  projectSearchAreaStatus: Boolean;
  showField: String;
  ref: any;
  downloadURL: Observable<string>;
  appointmentList: any[] = [];
  reminderList: any[] = [];
  noteList: any[] = [];
  // loadNext:Boolean=false;
  categoryList = [];
  neededDocuments: any[] = [];
  step2PreconditionId: String[] = [];
  // step2FulfillingProjectIds:String[] = [];
  // step2FieldIds:any[]=[];
  fileList: any[] = [];
  showSchedule;
  technicalDesignerList: any[] = [];
  sendToProductionStatus: Boolean = false;
  contactData: any;
  curProject: String;
  curTab: String = "";
  notSendEmail: String[] = [
    "AJNF8kai80awhOqdyriE",
    "3xPNW91yXwtfzPGwYbKQ",
    "sidc1JE2dl5ULVDN9oU5",
    "F3T9MchJCsVzqqdVvtKA",
    "Hl1fu22xaQCXJYM9kOuP",
    "dTuXL5JW8iSrZCGdDQXJ",
    "keJkG4i9ZRGhc23pgIiy",
    "tgcqF7VCNZPTwRmlvzdW",
    "BSlQmkony0t3PkqRPiOv",
    "1O9VYmrtoJIoxTZRVXAz",
    "KizAgomsXDIRtTwSnuVI",
    "IeETmE82P0ADVxMZjhg6",
    "sxVy1Aj0AmObwXkXT6NC",
    "ksvqcM3caUhybNM9Z6PJ",
    "pQKV2Kz5lkQFomjiAB7M",
    "qyMJbAWjGXB9eYPxcT0v",
    "igaF8mbHPesUBMTgGlIk",
  ];
  fieldUpdate: any[] = [
    {
      field_id: "xRXVxF0c7u4CZFZsg2gO",
      update_obj: {retainer_agreement_added: "Yes"},
    },
    {field_id: "Zy3PlGuCMUSGheaoI8sp", update_obj: {floor_plan_added: "Yes"}},
    {field_id: "a1PxDbztOzyX5TkGkHW1", update_obj: {design_added: "Yes"}},
    {
      field_id: "pyHdp66THa5G04GAquMr",
      update_obj: {desired_production_week_added: "Yes"},
    },
    {
      field_id: "tASShhH47wpRYFkkQbPr",
      update_obj: {updated_design_added: "Yes"},
    },
    {field_id: "16jq0ASz1FsSP2HbRSBb", update_obj: {size_added: "Yes"}},
    {field_id: "2xRks4oV4X2XHFTstXtO"},
    {field_id: "8Mwe89gcvBYNuOuurhVe", update_obj: {complexity_added: "Yes"}},
    {field_id: "99KrwVmq0xNOnrYs3xoE", update_obj: {brand_added: "Yes"}},
    {
      field_id: "Aa0mO4IwJOBMq6t46EpL",
      update_obj: {amount_of_cabinets_added: "Yes"},
    },
    {
      field_id: "hdTkfyCa5Vc6N0KouQM0",
      update_obj: {walk_through_checklist_added: "Yes"},
    },
    {
      field_id: "S9sBI93pFQryXyV6a5xw",
      update_obj: {walk_through_measurements_added: "Yes"},
    },
    {field_id: "Wv8Acm3vQspa2zP4ireH", update_obj: {site_photos_added: "Yes"}},
    {
      field_id: "EZqW8QL9dwgImazd7oDp",
      update_obj: {appliances_form_added: "Yes"},
    },
    {
      field_id: "xmBq40fr0zlZ00pxTJvA",
      update_obj: {style_selection_form_added: "Yes"},
    },
    {field_id: "1cPSWuR2lklh6WrDV45H", update_obj: {kps_added: "Yes"}},
    {
      field_id: "Qe60jcBLSkYneVSJHlVO",
      update_obj: {installation_required_added: "Yes"},
    },
    {
      field_id: "MYk4iyBUC7ov2ulmO82u",
      update_obj: {appliances_purchased_added: "Yes"},
    },
    {field_id: "0SfMD1NzS7wADpK8CnMl", update_obj: {paid_invoice_added: "Yes"}},
    {
      field_id: "3xPNW91yXwtfzPGwYbKQ",
      update_obj: {purchase_agreement_cabinetry_added: "Yes"},
    },
    {
      field_id: "sDrj14gZbe9hCicAgZ2C",
      update_obj: {mechanical_plan_added: "Yes"},
    },
    {
      field_id: "90vBMjb3ueK4kcja4CGD",
      update_obj: {step5_review_request_date_created: new Date().getTime()},
    },
    {
      field_id: "dTuXL5JW8iSrZCGdDQXJ",
      update_obj: {
        installation_plans_added: "Yes",
        installation_plans_approved: "No",
      },
    },
    {
      field_id: "keJkG4i9ZRGhc23pgIiy",
      update_obj: {
        order_confirmation_added: "Yes",
        order_confirmation_approved: "No",
      },
    },
    {
      field_id: "tgcqF7VCNZPTwRmlvzdW",
      update_obj: {perspectives_added: "Yes", perspectives_approved: "No"},
    },
    {
      field_id: "BSlQmkony0t3PkqRPiOv",
      update_obj: {
        appliance_spec_package_added: "Yes",
        appliance_spec_package_approved: "No",
      },
    },
    {
      field_id: "03OG6ByYwQbbKxDMtJMl",
      update_obj: {
        appliance_spec_package_added: "Yes",
        appliance_spec_package_approved: "No",
      },
    },
    {
      field_id: "1O9VYmrtoJIoxTZRVXAz",
      update_obj: {delivery_photos_added: "Yes"},
    },
    {
      field_id: "KizAgomsXDIRtTwSnuVI",
      update_obj: {delivery_confirmation_added: "Yes"},
    },
    {
      field_id: "ftEJXgXxLJSx7TURKR1X",
      update_obj: {delivery_photos_added: "Yes"},
    },
  ];
  curProjectIds: any;
  multiFileFieldArr = [
    "pFTqLhQyPGx4xhhsmRqU",
    "Wv8Acm3vQspa2zP4ireH",
    "keJkG4i9ZRGhc23pgIiy",
    "1O9VYmrtoJIoxTZRVXAz",
    "KizAgomsXDIRtTwSnuVI",
    "IeETmE82P0ADVxMZjhg6",
    "igaF8mbHPesUBMTgGlIk",
    "ksvqcM3caUhybNM9Z6PJ",
    "pQKV2Kz5lkQFomjiAB7M",
    "qyMJbAWjGXB9eYPxcT0v",
    "sxVy1Aj0AmObwXkXT6NC",
    "DZhmDe7EHwrewjqKwjaR",
  ];

  limit = 10;
  totalProjects = 11;
  paginationClickedCount = 0;
  prevStartAt: [] = [];
  disableNext: Boolean = false;
  disablePrev: Boolean = false;

  firstInResponse: any = []; //Save first document in snapshot of items received
  lastInResponse: any = []; //Save last document in snapshot of items received

  //Keep the array of first document of previous pages
  prev_strt_at: any = [];
  //Maintain the count of clicks on Next Prev button
  pagination_clicked_count = 0;
  //Disable next and prev buttons
  disable_next: boolean = false;
  disable_prev: boolean = false;
  isLoading: Boolean;
  allRecordFetched = false;
  pageCounter = 0;
  currentProjectId: string;
  currentContactId: string;
  projectIndex: number;
  private subscription: Subscription;
  private subscription2: Subscription;
  private subscription3: Subscription;
  private subscription4: Subscription;
  private subscription5: Subscription;
  private subscription6: Subscription;
  private subscription7: Subscription;
  private subscription8: Subscription;
  private subscription9: Subscription;
  private subscription10: Subscription;
  private subscription11: Subscription;
  private subscription12: Subscription;
  private subscription13: Subscription;
  private subscription14: Subscription;
  private subscription15: Subscription;
  // private subscription16: Subscription;
  private subscription17: Subscription;
  constructor(
    public dialog: MatDialog,
    private afStorage: AngularFireStorage,
    private _common: CommonService,
    private _admin: AdminService,
    private _project: ProjectService,
    private _alert: AlertService,
    private _profile: ProfileService,
    private _toastr: ToastrService,
    private _file: FileService,
    public _lead: LeadService,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    if (firebase.apps.length < 2) {
      const app = firebase.initializeApp(environment.firebaseConfig);
      if (window.location.host.includes("localhost")) {
        app.functions().useFunctionsEmulator("http://localhost:5000");
      }
    }
    var db = firebase.firestore();

    this._profile.projectSearchArea.subscribe((status) => {
      this.projectSearchAreaStatus = status["show"];
    });

    this.getProjectList();
    this.getProjectMapStepField();

    this.getTechnicalDesigner();

    // this.getStep2FieldIds();

    this._profile.sendToProduction.subscribe((res: any) => {
      if (res.status === true) {
        // if(document.getElementById(res.project_id)!==null){
        //   document.getElementById(res.project_id).innerHTML = '<strong>Successfully sent to production</strong>';
        // }
        this.showDetailData(this.currentProjectId, this.currentContactId, true);
      }
    });

    this._profile.requestDelivery.subscribe((res: any) => {
      if (res === this.currentProjectId) {
        this.showDetailData(this.currentProjectId, this.currentContactId, true);
      }
    });
  }

  exportexcel(): void {
    /* table id is passed over here */
    //  let element = document.getElementById('lead-listing');

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.excelArray);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  @HostListener("window:scroll", [])
  onScroll(): void {
    if (window.innerHeight + window.scrollY >= document.body.scrollHeight) {
      if (this.isLoading === false && this.allRecordFetched === false) {
        this.nextPage();
      }
    }
  }

  // get categories list...
  /*getStepDocCategoryList(){
    this._lead.getCategoriesList().subscribe(categoryList=>{
      for(let i=0; i< categoryList.length;i++){
        const index = this.neededDocuments.findIndex(item => item.step_id === categoryList[i].payload.doc.data()['project_map_step_id']);
        if(index===-1){
          let data = {
            step_id : categoryList[i].payload.doc.data()['project_map_step_id'],
            docs : [categoryList[i].payload.doc.data()]
          }
          // this.neededDocuments.categoryList[i].payload.doc.data()['project_map_step_id'] = [categoryList[i].payload.doc.data()];
        }
        else{
          this.neededDocuments[i]['docs'].push(categoryList[i].payload.doc.data()['project_map_step_id']);
        }
      }
    },error=>{
      this._alert.error(error.error.message?error.error.message:'Something went wrong!');
    });

  }*/

  /*checkStep2Precondition(){
    // Code to get the id for the field Retainer Agreement && Purchase Agreement (Cabinetry)
    this._project.getIdsForStep2Precondition().subscribe((res)=>{
      if(res.length>0){
        this.step2PreconditionId = res.map(item=> item.payload.doc.id);
        this._project.checkStep2Precondition(this.step2PreconditionId).subscribe((res2)=>{
          this.step2FulfillingProjectIds = res2.map(item=>item.payload.doc.data()['project_id']);
        },err=>{
          this.errMsg = err.error.message?err.error.message:'Something went wrong!';
        })
      }
    },err=>{
      this.errMsg = err.error.message?err.error.message:'Something went wrong!';
    })
  }*/

  /*  getStep2FieldIds(){ // Code to get the step 2 field id
    this._project.getStep2FieldIds().subscribe((res)=>{
      if(res.length>0){
        this.step2FieldIds = res.map(item=> item.payload.doc.id);
      }
    },err=>{
      this.errMsg = err.error.message?err.error.message:'Something went wrong!';
    })
  }*/

  getTechnicalDesigner() {
    this.subscription = this._project.getTechnicalDesigner().subscribe(
      (res) => {
        if (res.length > 0) {
          this.technicalDesignerList = res.map((item) =>
            item.payload.doc.data()
          );
        }
      },
      (err) => {
        this.errMsg =
          err.error && err.error.message
            ? err.error.message
            : "Something went wrong!";
      }
    );
  }

  getProjectList() {
    const listType = emailList.includes(localStorage.getItem("rs-email"))
      ? "all"
      : "filtered";
    this.items = [];
    this._common.showLoader(true);
    this.isLoading = true;
    let filterData = {};
    this.subscription2 = this._project
      .getProjectList(
        this.limit,
        filterData,
        localStorage.getItem("uid"),
        listType
      )
      .subscribe(
        (res) => {
          this._common.showLoader(false);
          if (res && res.length === 0) {
            this.allRecordFetched = true;
            this.errMsg = "No Data Available";
          } else {
            if (res && res.length < 10) {
              this.allRecordFetched = true;
            }
            this.errMsg = "";
            this.firstInResponse = res[0].payload.doc;
            this.lastInResponse = res[res.length - 1].payload.doc;
          }

          //Initialize values
          this.prev_strt_at = [];
          this.pagination_clicked_count = 0;
          this.disable_next = false;
          this.disable_prev = false;
          //Push first item to use for Previous action
          this.push_prev_startAt(this.firstInResponse);
          const newList = res.map((v) => ({...v, open: false}));
          this.items = newList;
          this.isLoading = false;
          if (window.screen.height > 900 && this.allRecordFetched === false) {
            this.nextPage();
          }
          // this.curProjectIds = this.items[0].map(item => item.payload.doc.id);

          // Load contact data
          // const contactIds = this.items[0].map(item=> item.payload.doc.data().contact_id);

          // const filteredArr = [...new Set(contactIds.filter(elm => elm))] ;
        },
        (error) => {
          this.isLoading = false;
          this._common.showLoader(false);
          this._alert.error(
            error.error && error.error.message
              ? error.error.message
              : "Something went wrong!"
          );
        }
      );
  }

  //Add document...
  push_prev_startAt(prev_first_doc) {
    this.prev_strt_at.push(prev_first_doc);
  }

  // Previous page....
  /* prevPage() {
    this.errMsg = "";
    this.disable_prev = true;
    const listType = emailList.includes(localStorage.getItem('rs-email')) ? 'all': 'filtered' ;
    this.items = [];
    this._project
    .getProjectList(this.limit, localStorage.getItem('uid'), listType, this.get_prev_startAt(), this.firstInResponse).subscribe(res =>{
      this.firstInResponse = res[0][0].payload.doc;
      this.lastInResponse = res[0][res[0].length - 1].payload.doc;
      this.items = res;
      // Load contact data
      const contactIds = this.items[0].map(item=> item.payload.doc.data().id);
      const filteredArr = [...new Set(contactIds.filter(elm => elm))] ;
      
      this._project.getProjectContactDetail(filteredArr).subscribe(res =>{
        this.contactData = res.map(item=> item.payload.doc.data());
        this._project.getAllFileList().subscribe((res)=>{ 
          this.fileList = res; //res.map(item=> item.payload.doc.data());
          this._common.showLoader(false);
        // iterate item for binding project list with dynamics steps and its value
        for(let j=0; j<this.items[0].length; j++){
          let contactIndex = this.contactData.findIndex(item=> item.id===this.items[0][j].payload.doc.data().contact_id);
          this.items[0][j].contactData = contactIndex=== -1 ? {showroom:[]} : this.contactData[contactIndex];
          this.items[0][j].projectStepList = this.projectStepList;

          this.items[0][j].scheduleWalkThrough = 0;
          // iterate field listing to update if the value/file for this is added
          this.newFieldList = [];
          for(let k=0;k<this.projectStepFieldList.length; k++){
            
            this.newFieldList.push([]);
            
            for(let l=0; l<this.projectStepFieldList[k].length; l++){
              this.newFieldList[k].push([]);   
              let fieldObj = {
                field_id : this.projectStepFieldList[k][l].payload.doc.id,
                field_type : this.projectStepFieldList[k][l].payload.doc.data().field_type,
                select_list : this.projectStepFieldList[k][l].payload.doc.data().select_list ? this.projectStepFieldList[k][l].payload.doc.data().select_list :[],
                project_map_step_id : this.projectStepFieldList[k][l].payload.doc.data().project_map_step_id,
                name: this.projectStepFieldList[k][l].payload.doc.data().name
              };
              
              for(let m=0; m<this.items[1][j].length;m++){
                if(this.projectStepFieldList[k][l].payload.doc.id===this.items[1][j][m].payload.doc.data().project_map_field_id && this.items[0][j].payload.doc.id===this.items[1][j][m].payload.doc.data().project_id){
                  let field_type = this.items[1][j][m].payload.doc.data().type;
                  let value = this.items[1][j][m].payload.doc.data().value;
                  let node_id = this.items[1][j][m].payload.doc.id;
                  fieldObj["addedData"] = {field_type,value, node_id, project_id:this.items[1][j][m].payload.doc.data().project_id};
                }
              }
              //check file data from files collection and set in the final array...
              let fileIndex = this.fileList.findIndex(item=> item.payload.doc.data().project_map_field_id===this.projectStepFieldList[k][l].payload.doc.id && item.payload.doc.data().project_id===this.items[0][j].payload.doc.id);

              if(fileIndex>-1){
                fieldObj["addedData"] = {field_type:'file',fb_storage_download_url: this.fileList[fileIndex].fbs_download_url, project_id:this.fileList[fileIndex].project_id,node_id: this.fileList[fileIndex].id, gd_file_id:this.fileList[fileIndex].payload.doc.data().gd_file_id, gd_folder_id : this.fileList[fileIndex].payload.doc.data().gd_folder_id};
              }
              this.newFieldList[k][l].push(fieldObj);
            }
            
            if(k+1 ==this.projectStepFieldList.length){
              this.items[0][j].projectStepFieldList = this.newFieldList; 
            }
          }
        } 
        },err=>{
          this.errMsg = err.error.message?err.error.message:'Something went wrong!';
        })
        
      },error=>{
        this._alert.error(error.error && error.error.message?error.error.message:'Something went wrong!');
      })

       //Maintaing page no.
       this.pagination_clicked_count--;

       //Pop not required value in array
       this.pop_prev_startAt(this.firstInResponse);
 
       //Enable buttons again
       this.disable_prev = false;
      //  if(this.totalProjects <=(this.pagination_clicked_count+1)*this.limit){
      //    this.disable_next = true;  
      //  }
      //  else{
      //    this.disable_next = false;
      //  }
      this.disable_next = false;
    },error=>{
      this.disable_prev = false;
      this._common.showLoader(false);
      this._alert.error(error.error && error.error.message?error.error.message:'Something went wrong!');
    });
  }
*/

  // Next Page record
  nextPage() {
    if (this.isLoading === false) {
      this.pageCounter += 1;
      this.isLoading = true;
      this.errMsg = "";
      this.disable_next = true;

      this.items2 = [];
      const listType = emailList.includes(localStorage.getItem("rs-email"))
        ? "all"
        : "filtered";

      this.subscription3 = this._project
        .getProjectList(
          this.limit,
          localStorage.getItem("uid"),
          listType,
          null,
          null,
          this.lastInResponse
        )
        .subscribe(
          (res) => {
            const newList = res.map((v) => ({...v, open: false}));
            if (!res[0].payload.doc) {
              this.disable_next = true;
              return;
            }
            this.firstInResponse = res[0].payload.doc;
            this.lastInResponse = res[res.length - 1].payload.doc;

            // this.lastInResponse = res.docs[res.docs.length - 1];

            Array.prototype.push.apply(this.items, newList);
            setTimeout(() => {
              this.isLoading = false;
            }, 1000);
            // this.items.push(res);
            // this.curProjectIds = this.items2[0].map(item => item.payload.doc.id);
            // Load contact data
            /*    const contactIds = this.items2[0].map(item=> item.payload.doc.data().contact_id);
      
      const filteredArr = [...new Set(contactIds.filter(elm => elm))] ;
      this._project.getProjectContactDetail(filteredArr).subscribe(res =>{
        this.contactData = res.map(item=> item.payload.doc.data());
        
        this._project.getProjectFiles(this.curProjectIds).subscribe((res)=>{
          this.fileList = res; 
          //res.map(item=> item.payload.doc.data());
          // this._common.showLoader(false);
        // iterate item for binding project list with dynamics steps and its value
        
        if(this.items2[0]!== undefined){
          for(let j=0; j<this.items2[0].length; j++){

            let contactIndex = this.contactData.findIndex(item=> item.id===this.items2[0][j].payload.doc.data().contact_id);
            this.items2[0][j].contactData = contactIndex=== -1 ? {showroom:[]} : this.contactData[contactIndex];
            this.items2[0][j].projectStepList = this.projectStepList;
            this.items2[0][j].scheduleWalkThrough = 0;
            // iterate field listing to update if the value/file for this is added
            this.newFieldList = [];
            for(let k=0;k<this.projectStepFieldList.length; k++){
              
              this.newFieldList.push([]);
              
              for(let l=0; l<this.projectStepFieldList[k].length; l++){
                this.newFieldList[k].push([]);   
                let fieldObj = {
                  field_id : this.projectStepFieldList[k][l].payload.doc.id,
                  field_type : this.projectStepFieldList[k][l].payload.doc.data().field_type,
                  select_list : this.projectStepFieldList[k][l].payload.doc.data().select_list ? this.projectStepFieldList[k][l].payload.doc.data().select_list :[],
                  project_map_step_id : this.projectStepFieldList[k][l].payload.doc.data().project_map_step_id,
                  name: this.projectStepFieldList[k][l].payload.doc.data().name
                };
      
                for(let m=0; m<this.items2[1][j].length;m++){
                  if(this.projectStepFieldList[k][l].payload.doc.id===this.items2[1][j][m].payload.doc.data().project_map_field_id && this.items2[0][j].payload.doc.id===this.items2[1][j][m].payload.doc.data().project_id){
                    let field_type = this.items2[1][j][m].payload.doc.data().type;
                    let value = this.items2[1][j][m].payload.doc.data().value;
                    let node_id = this.items2[1][j][m].payload.doc.id;
                    fieldObj["addedData"] = {field_type,value, node_id, project_id:this.items2[1][j][m].payload.doc.data().project_id};
                  }
                }
                //check file data from files collection and set in the final array...
                let fileIndex = this.fileList.findIndex(item=> item.payload.doc.data().project_map_field_id===this.projectStepFieldList[k][l].payload.doc.id && item.payload.doc.data().project_id===this.items2[0][j].payload.doc.id);
  
                if(fileIndex>-1){
                  fieldObj["addedData"] = {field_type:'file',fb_storage_download_url: this.fileList[fileIndex].fbs_download_url, project_id:this.fileList[fileIndex].project_id,node_id: this.fileList[fileIndex].id, gd_file_id:this.fileList[fileIndex].payload.doc.data().gd_file_id, gd_folder_id : this.fileList[fileIndex].payload.doc.data().gd_folder_id};
                }
                this.newFieldList[k][l].push(fieldObj);
              }
              
              if(k+1 ==this.projectStepFieldList.length){
                this.items2[0][j].projectStepFieldList = this.newFieldList; 
              }
            }
            // 
            // if(j+1 == this.items2[0].length){
            //   this.items[0].concat(this.items2[0]);
            //   this.items[1].concat(this.items2[1]);
            // }
            this.items[0].push(this.items2[0][j]);
            this.items[1].push(this.items2[1][j]);
          } 
        }

        this.loadAppointmentReminderNotes(this.curProjectIds, this.pageCounter); 
        // setTimeout(()=>{
          this.isLoading = false;
        //   // this.nextPage();
        // },2000);
        },err=>{
          this.isLoading = false;
          this.errMsg = err.error.message?err.error.message:'Something went wrong!';
        })
        
      },error=>{
        this.isLoading = false;
        this._alert.error(error.error && error.error.message?error.error.message:'Something went wrong!');
      })
*/
            this.pagination_clicked_count++;

            this.push_prev_startAt(this.firstInResponse);
            // if(this.totalProjects<=(this.pagination_clicked_count+1)*this.limit){
            //   this.disable_next = true;
            // }
            // else{
            //   this.disable_next = false;
            // }
            this.disable_next = false;
          },
          (error) => {
            this.disable_next = false;
            // this._common.showLoader(false);
            this._alert.error(
              error.error && error.error.message
                ? error.error.message
                : "Something went wrong!"
            );
          }
        );
    }
  }

  //Remove not required document
  pop_prev_startAt(prev_first_doc) {
    this.prev_strt_at.forEach((element) => {
      if (prev_first_doc.data().id == element.data().id) {
        element = null;
      }
    });
  }

  //Return the Doc rem where previous page will startAt
  get_prev_startAt() {
    if (this.prev_strt_at.length > this.pagination_clicked_count + 1)
      this.prev_strt_at.splice(
        this.prev_strt_at.length - 2,
        this.prev_strt_at.length - 1
      );
    return this.prev_strt_at[this.pagination_clicked_count - 1];
  }

  showDetailData(projectId, contactId, rendering = null) {
    if (this.currentProjectId != projectId || rendering != null) {
      // this._common.showLoader(true);
      this.currentProjectId = projectId;
      this.currentContactId = contactId;
      this.appointmentList = [];
      this.reminderList = [];
      this.noteList = [];
      this.projectIndex = this.items.findIndex(
        (item) => item.payload.doc.id === projectId
      );
      this.items[this.projectIndex].open = true;
      this.subscription4 = this._project
        .getProjectContactDetail(contactId)
        .subscribe(
          (contact) => {
            this.contactData =
              contact && contact.length > 0
                ? contact[0].payload.doc.data()
                : {};

            // Fetch Project map node....
            this.subscription5 = this._project
              .getProjectMapNode(projectId)
              .subscribe(
                (nodes) => {
                  this.subscription6 = this._project
                    .getProjectFiles(projectId)
                    .subscribe(
                      (files) => {
                        this.fileList = files;
                        this.items[this.projectIndex].projectStepList =
                          this.projectStepList;
                        this.items[this.projectIndex].scheduleWalkThrough = 0;
                        this.newFieldList = [];
                        for (
                          let k = 0;
                          k < this.projectStepFieldList.length;
                          k++
                        ) {
                          this.newFieldList.push([]);

                          for (
                            let l = 0;
                            l < this.projectStepFieldList[k].length;
                            l++
                          ) {
                            this.newFieldList[k].push([]);
                            let fieldObj = {
                              field_id:
                                this.projectStepFieldList[k][l].payload.doc.id,
                              field_type:
                                this.projectStepFieldList[k][
                                  l
                                ].payload.doc.data().field_type,
                              select_list: this.projectStepFieldList[k][
                                l
                              ].payload.doc.data().select_list
                                ? this.projectStepFieldList[k][
                                    l
                                  ].payload.doc.data().select_list
                                : [],
                              project_map_step_id:
                                this.projectStepFieldList[k][
                                  l
                                ].payload.doc.data().project_map_step_id,
                              name: this.projectStepFieldList[k][
                                l
                              ].payload.doc.data().name,
                            };

                            for (let m = 0; m < nodes.length; m++) {
                              if (
                                this.projectStepFieldList[k][l].payload.doc
                                  .id ===
                                nodes[m].payload.doc.data()[
                                  "project_map_field_id"
                                ]
                              ) {
                                let field_type =
                                  nodes[m].payload.doc.data()["type"];
                                let value =
                                  nodes[m].payload.doc.data()["value"];
                                let node_id = nodes[m].payload.doc.id;
                                fieldObj["addedData"] = {
                                  field_type,
                                  value,
                                  node_id,
                                  project_id: projectId,
                                };
                              }
                            }
                            //check file data from files collection and set in the final array...
                            let fileIndex = this.fileList.findIndex(
                              (item) =>
                                item.payload.doc.data().project_map_field_id ===
                                  this.projectStepFieldList[k][l].payload.doc
                                    .id &&
                                item.payload.doc.data().project_id ===
                                  this.items[this.projectIndex].payload.doc.id
                            );

                            if (fileIndex > -1) {
                              fieldObj["addedData"] = {
                                field_type: "file",
                                fb_storage_download_url:
                                  this.fileList[fileIndex].fbs_download_url,
                                project_id: this.fileList[fileIndex].project_id,
                                node_id: this.fileList[fileIndex].id,
                                gd_file_id:
                                  this.fileList[fileIndex].payload.doc.data()
                                    .gd_file_id,
                                gd_folder_id:
                                  this.fileList[fileIndex].payload.doc.data()
                                    .gd_folder_id,
                              };
                            }
                            this.newFieldList[k][l].push(fieldObj);
                          }

                          if (k + 1 == this.projectStepFieldList.length) {
                            this.items[this.projectIndex].projectStepFieldList =
                              this.newFieldList;
                          }
                          // Load Appointment, Reminders, Notes...
                          this.subscription7 = this._project
                            .getProjectAppointmentList(projectId)
                            .subscribe(
                              (result) => {
                                this.appointmentList = result;
                              },
                              (err) => {
                                // this._common.showLoader(false);
                                this._alert.error(
                                  err.error && err.error.message
                                    ? err.error.message
                                    : "Something went wrong!"
                                );
                              }
                            );
                          // fetch reminder list...
                          this.subscription8 = this._project
                            .getProjectReminderList(projectId)
                            .subscribe(
                              (result2) => {
                                this.reminderList = result2;
                              },
                              (err) => {
                                // this._common.showLoader(false);
                                this._alert.error(
                                  err.error && err.error.message
                                    ? err.error.message
                                    : "Something went wrong!"
                                );
                              }
                            );
                          // fetch notes list...
                          this.subscription9 = this._project
                            .getProjectNotesList(projectId)
                            .subscribe(
                              (result3) => {
                                this.noteList = result3;
                                // this._common.showLoader(false);
                              },
                              (err) => {
                                // this._common.showLoader(false);
                                this._alert.error(
                                  err.error && err.error.message
                                    ? err.error.message
                                    : "Something went wrong!"
                                );
                              }
                            );
                        }
                      },
                      (err) => {
                        this.isLoading = false;
                        this.errMsg =
                          err.error && err.error.message
                            ? err.error.message
                            : "Something went wrong!";
                      }
                    );
                },
                (err) => {
                  this.isLoading = false;
                  this.errMsg =
                    err.error && err.error.message
                      ? err.error.message
                      : "Something went wrong!";
                }
              );
            /*      this._project.getProjectFiles(projectId).subscribe((res)=>{
          this.fileList = res;
          // iterate item for binding project list with dynamics steps and its value
          for(let j=0; j<this.items[0].length; j++){
            let contactIndex = this.contactData.findIndex(item=> item.id===this.items[0][j].payload.doc.data().contact_id);
            this.items[0][j].contactData = contactIndex=== -1 ? {showroom:[]} : this.contactData[contactIndex];
            
            this.items[0][j].projectStepList = this.projectStepList;
            this.items[0][j].scheduleWalkThrough = 0;
            // iterate field listing to update if the value/file for this is added
            this.newFieldList = [];
            for(let k=0;k<this.projectStepFieldList.length; k++){
              
              this.newFieldList.push([]);
              
              for(let l=0; l<this.projectStepFieldList[k].length; l++){
                this.newFieldList[k].push([]);   
                let fieldObj = {
                  field_id : this.projectStepFieldList[k][l].payload.doc.id,
                  field_type : this.projectStepFieldList[k][l].payload.doc.data().field_type,
                  select_list : this.projectStepFieldList[k][l].payload.doc.data().select_list ? this.projectStepFieldList[k][l].payload.doc.data().select_list :[],
                  project_map_step_id : this.projectStepFieldList[k][l].payload.doc.data().project_map_step_id,
                  name: this.projectStepFieldList[k][l].payload.doc.data().name
                };
      
                for(let m=0; m<this.items[1][j].length;m++){
                  if(this.projectStepFieldList[k][l].payload.doc.id===this.items[1][j][m].payload.doc.data().project_map_field_id && this.items[0][j].payload.doc.id===this.items[1][j][m].payload.doc.data().project_id){
                    let field_type = this.items[1][j][m].payload.doc.data().type;
                    let value = this.items[1][j][m].payload.doc.data().value;
                    let node_id = this.items[1][j][m].payload.doc.id;
                    fieldObj["addedData"] = {field_type,value, node_id, project_id:this.items[1][j][m].payload.doc.data().project_id};
                  }
                }
                //check file data from files collection and set in the final array...
                let fileIndex = this.fileList.findIndex(item=> item.payload.doc.data().project_map_field_id===this.projectStepFieldList[k][l].payload.doc.id && item.payload.doc.data().project_id===this.items[0][j].payload.doc.id);
  
                if(fileIndex>-1){
                  fieldObj["addedData"] = {field_type:'file',fb_storage_download_url: this.fileList[fileIndex].fbs_download_url, project_id:this.fileList[fileIndex].project_id,node_id: this.fileList[fileIndex].id, gd_file_id:this.fileList[fileIndex].payload.doc.data().gd_file_id, gd_folder_id : this.fileList[fileIndex].payload.doc.data().gd_folder_id};
                }
                this.newFieldList[k][l].push(fieldObj);
              }
              
              if(k+1 ==this.projectStepFieldList.length){
                this.items[0][j].projectStepFieldList = this.newFieldList; 
                
              }
            }        
          } 
        
        this.loadAppointmentReminderNotes(this.curProjectIds, this.pageCounter);
        setTimeout(()=>{
          this.isLoading = false;
          if(window.screen.height>900){
            this.nextPage();
          }
        },2000);
        },err=>{
          this.isLoading = false;
          this.errMsg = err.error.message?err.error.message:'Something went wrong!';
        }) */
          },
          (error) => {
            this.isLoading = false;
            this._alert.error(
              error.error && error.error.message
                ? error.error.message
                : "Something went wrong!"
            );
          }
        );
    }
  }

  openAddProjectDialog() {
    this.dialog.open(AddProjectDialogComponent, {
      width: "auto",
    });
  }

  openEditProjectDialog(id) {
    let dialogRef = this.dialog.open(EditProjectDialogComponent, {
      width: "auto",
      data: {
        id: id,
      },
    });

    dialogRef.afterClosed().subscribe((response) => {
      // this.getUserList(localStorage.getItem('uid'))
    });
  }
  // delete project
  deleteProject(id) {
    this._common.showLoader(true);
    // delete project data over algolia

    this._admin
      .deleteProject(id)
      .then((res) => {
        index
          .deleteObjects([id])
          .then(({objectIDs}) => {
            this._common.showLoader(false);
            this.successMsg = "Project deleted successfully!";
          })
          .catch((err) => {
            this.errMsg = "Something went wrong while updating over Algolia";
          });
      })
      .catch((err) => {
        this._common.showLoader(false);
        this.errMsg = err.error.message
          ? err.error.message
          : "Something went wrong!";
      });
  }

  // get project map field
  getProjectMapStepField() {
    this.subscription10 = this._project.getProjectMapStep().subscribe(
      (res) => {
        this.projectStepList = res[0];
        // code to fetch the project map step category...
        this.subscription11 = this._lead.getCategoriesList().subscribe(
          (categoryList) => {
            // code to fetch the project map step category file...
            this.subscription12 = this._lead.getCategoryFileList().subscribe(
              (fileList) => {
                // remove previously fetched data with below for loop...
                for (let k = 0; k < this.projectStepList.length; k++) {
                  this.projectStepList[k].docs = [];
                }
                for (let i = 0; i < categoryList.length; i++) {
                  const index = this.projectStepList.findIndex(
                    (item) =>
                      item.payload.doc.id ===
                      categoryList[i].payload.doc.data()["project_map_step_id"]
                  );
                  if (index > -1) {
                    // fetch files for current category
                    let files = [];
                    for (let j = 0; j < fileList.length; j++) {
                      if (
                        fileList[j].payload.doc.data()[
                          "project_map_step_category_id"
                        ] === categoryList[i].payload.doc.id
                      ) {
                        files.push(fileList[j].payload.doc.data());
                      }
                    }
                    let obj = {
                      id: categoryList[i].payload.doc.data()["id"],
                      date_created:
                        categoryList[i].payload.doc.data()["date_created"],
                      name: categoryList[i].payload.doc.data()["name"],
                      project_map_step_id:
                        categoryList[i].payload.doc.data()[
                          "project_map_step_id"
                        ],
                      files: files,
                    };

                    this.projectStepList[index].docs.push(obj);
                  }
                }
              },
              (error) => {
                this._alert.error(
                  error.error && error.error.message
                    ? error.error.message
                    : "Something went wrong!"
                );
              }
            );
          },
          (error) => {
            this._alert.error(
              error.error && error.error.message
                ? error.error.message
                : "Something went wrong!"
            );
          }
        );
        this.projectStepFieldList = res[1];
      },
      (err) => {
        this.errMsg =
          err.error && err.error.message
            ? err.error.message
            : "Something went wrong!";
      }
    );
  }

  // upload image as promise
  /*  uploadImageAsPromise(randomId, fileName, fileData, project_id) {
    
      this.ref = this.afStorage.ref(`projects/${project_id}/${randomId}-${fileName}`);
      const task = this.afStorage.upload(`projects/${project_id}/${randomId}-${fileName}`, fileData);
      return new Promise((resolve, reject)=>{
     
      return task.snapshotChanges().pipe(
        finalize(() => {
            this.downloadURL = this.ref.getDownloadURL();
            this.downloadURL.subscribe(url => {
              if (url) {
                resolve(url);
              }
              else {
                reject({"status":"error"});
              }
          });
        })
      )
    })    
  }*/

  // Upload file
  async uploadFile(
    event,
    step_id,
    node_id,
    contact_id,
    step_name,
    step_number,
    project_name,
    project_map_step_field_name,
    project_map_step_field_id,
    contact_first_name,
    contact_last_name,
    owner_contact_id,
    owner_user_id,
    accouting_ref,
    list_iteration
  ) {
    this.curTab = `${list_iteration}${step_id}`;
    this._common.showLoader(true);
    this.isLoading = true;
    const file = (event.target as HTMLInputElement).files;
    const project_id = event.target.id.split(",")[1];

    const field_id = event.target.id.split(",")[0];

    const uid = localStorage.getItem("uid");
    for (let i = 0; i < file.length; i++) {
      const randomId = Math.random().toString(36).substring(2);
      const fileName = `${randomId}-${event.target.files[i].name}`;
      this.ref = this.afStorage.ref(
        `projects/${project_id}/${randomId}-${event.target.files[i].name}`
      );
      const task = await this.afStorage.upload(
        `projects/${project_id}/${randomId}-${event.target.files[i].name}`,
        event.target.files[i]
      );
      const file_type = file[0].type;
      // this.uploadImageAsPromise(randomId, fileName, event.target.files[i], project_id ).then(res=>{
      // }).catch(err=>{
      // })
      // task.snapshotChanges().pipe(
      //   finalize(() => {
      let tempStepId =
        field_id === "Hl1fu22xaQCXJYM9kOuP" ? "evwdciVNp0SQ6Qwxd790" : step_id; // Update the step id for Pre-delivery Checklist File Field
      this.downloadURL = this.ref.getDownloadURL();
      this.downloadURL.subscribe((url) => {
        if (url) {
          let data = {
            download_url: url,
            project_id: project_id,
            step_id: tempStepId,
            field_id: field_id,
            fbs_path: `projects/${project_id}/${randomId}-${event.target.files[i].name}`,
            type: "file",
            node_id: node_id,
            uid: localStorage.getItem("uid"),
            fileName,
            contact_id,
            step_name,
            project_map_step_field_name,
            file_type,
            owner_contact_id,
            owner_user_id,
          };
          var functions = firebase.functions();
          let createFile = firebase.functions().httpsCallable("create_file");

          createFile(data).then(
            (result) => {
              // Upload success
              this.curProject = data.project_id;
              // Update projects collection
              const UploadIndex = this.fieldUpdate.findIndex(
                (item) => item.field_id === project_map_step_field_id
              );
              if (UploadIndex > -1) {
                this._admin
                  .editProject(
                    this.fieldUpdate[UploadIndex].update_obj,
                    project_id
                  )
                  .then(
                    (res) => {},
                    (err) => {
                      this._toastr.success(`Something went wrong!`, "", {
                        timeOut: 4000,
                      });
                    }
                  );
              }
              // this._toastr.success("request sent!!!!","",{ timeOut: 4000 });
              if (i + 1 === file.length) {
                // Create drive file link:
                let driveLink = "";
                if (
                  this.multiFileFieldArr.includes(project_map_step_field_id)
                ) {
                  driveLink =
                    "https://drive.google.com/drive/u/1/folders/" +
                    result.data.gd_folder_id;
                } else {
                  driveLink =
                    "https://drive.google.com/file/d/" +
                    result.data.gd_file_id +
                    "/view";
                }

                if (
                  this.notSendEmail.indexOf(project_map_step_field_id) === -1
                ) {
                  // Code to get the desiger detail....
                  this.subscription13 = this._lead
                    .getContactDetail(owner_contact_id)
                    .subscribe(
                      (designer) => {
                        let cc;

                        if (
                          project_map_step_field_id === "90vBMjb3ueK4kcja4CGD"
                        ) {
                          cc = `rs@gregorysmith.ws,nurit@gregorysmith.ws,helya@gregorysmith.ws,${
                            designer.payload.data()["email"]
                          }`;
                        } else if (
                          project_map_step_field_id === "03OG6ByYwQbbKxDMtJMl"
                        ) {
                          cc = `accounting_gkc@gregorysmith.ws,processing_gkc@gregorysmith.ws,nurit@gregorysmith.ws,michalosher_gkc@gregorysmith.ws,${
                            designer.payload.data()["email"]
                          }`;
                        } else {
                          cc = `gs@gregorysmith.ws,t@gregorysmith.ws,t2@gregorysmith.ws,${
                            designer.payload.data()
                              ? designer.payload.data()["email"]
                              : ""
                          }`;
                        }
                        //Code to send email
                        const accoutingRef =
                          accouting_ref && accouting_ref != ""
                            ? `REF# ${accouting_ref} - `
                            : "";
                        const designerFirstName =
                          designer &&
                          designer.payload &&
                          designer.payload.data() &&
                          designer.payload.data()["first_name"]
                            ? designer.payload.data()["first_name"]
                            : "";
                        const designerLastName =
                          designer &&
                          designer.payload &&
                          designer.payload.data() &&
                          designer.payload.data()["last_name"]
                            ? designer.payload.data()["last_name"]
                            : "";

                        const mailBody = {
                          to: "rs@leichtnewyork.com",
                          subject: `${accoutingRef}${contact_first_name} ${contact_last_name} - ${project_name} - Step ${step_number} - ${project_map_step_field_name}`,
                          body: `Name: ${contact_first_name} ${contact_last_name}<br/> Designer: ${designerFirstName} ${designerLastName} <br/> Download: ${driveLink}<br/>Account: ${environment.appUrl}contact/${contact_id} <br/>Project: ${environment.appUrl}project/${project_id}<br/><br/>-<br/>Automated email sent via RS`,
                          cc: cc,
                        };

                        this._project.initEmail(mailBody).subscribe(
                          (res) => {
                            if (res) {
                              this._toastr.success(
                                `File uploaded successfully, Mail sent`,
                                ""
                              ); //,{ timeOut: 4000 }
                              this._common.showLoader(false);
                              this.isLoading = false;

                              /*
                          const curTab = document.getElementById(`nav-home-tab851${list_iteration}${step_id}`);
                          if(curTab!=null){
                            setTimeout(()=>{
                              curTab.classList.add("active");
                            },5000)
                          } */
                            }
                          },
                          (err) => {
                            this._toastr.success(
                              `File uploaded successfully, Mail not sent`,
                              ""
                            ); // ,{ timeOut: 4000 }
                            this._common.showLoader(false);
                            this.isLoading = false;

                            /*
                        const curTab = document.getElementById(`nav-home-tab851${list_iteration}${step_id}`);
                        if(curTab!=null){
                          curTab.classList.add("active");
                        }                        
                        */
                          }
                        );
                      },
                      (err) => {
                        this._toastr.error(
                          `${
                            err && err.error && err.error.message
                              ? err.error.message
                              : "Something went wrong!"
                          }`,
                          "",
                          {timeOut: 4000}
                        );
                        this._common.showLoader(false);
                        this.isLoading = false;
                      }
                    );
                } else {
                  this._toastr.success("File uploaded successfully!", "", {
                    timeOut: 4000,
                  });
                  this._common.showLoader(false);
                  this.isLoading = false;
                }
              }
              this.showDetailData(
                this.currentProjectId,
                this.currentContactId,
                true
              );
            },
            (err) => {
              this._common.showLoader(false);
              this.isLoading = false;
              this._toastr.error(
                `${
                  err && err.error && err.error.message
                    ? err.error.message
                    : "Something went wrong!"
                }`,
                "",
                {timeOut: 4000}
              );
            }
          );
        }
      });
      //   })
      // ).subscribe(url => {})
    }
  }

  /*showPreview(event,step_id,node_id) {
    const file = (event.target as HTMLInputElement).files[0];
    this.dialog.open(AddProjectMapStepFileDialogComponent, {
      width: 'auto',
      data:{
        img: event.target.files[0],
        step_id: step_id,
        project_id : event.target.id.split(',')[1],
        field_id : event.target.id.split(',')[0],
        node_id: node_id
      }
    }); 
    
  }*/

  //Save field data...
  createProjectMapNode(
    project_id,
    step_id,
    project_map_step_field_id,
    project_num,
    node_id,
    contact_id,
    step_number,
    project_map_step_field_name,
    type
  ) {
    this.curTab = `${project_num}${step_id}`;
    this._common.showLoader(true);
    let inputVal = (
      document.getElementById(
        `${project_map_step_field_id}${project_num}`
      ) as HTMLInputElement
    ).value;
    if (node_id) {
      this._project.updateNode(node_id, {value: inputVal}).then(
        (res) => {
          const UploadIndex = this.fieldUpdate.findIndex(
            (item) => item.field_id === project_map_step_field_id
          );
          if (UploadIndex > -1) {
            let obj =
              project_map_step_field_id === "2xRks4oV4X2XHFTstXtO"
                ? {accounting_ref: inputVal}
                : this.fieldUpdate[UploadIndex].update_obj;
            this._admin.editProject(obj, project_id).then(
              (res) => {},
              (err) => {
                this._toastr.success(`Something went wrong!`, "", {
                  timeOut: 4000,
                });
              }
            );
          }
          this._common.showLoader(false);
          this._toastr.success("Node successfully updated", "", {
            timeOut: 4000,
          });
        },
        (err) => {
          this._common.showLoader(false);
          this._toastr.error("Something went wrong", "", {timeOut: 4000});
        }
      );
    } else {
      let data = {
        value: inputVal,
        contact_id: contact_id,
        project_map_field_id: project_map_step_field_id,
        project_map_step_number: step_number,
        project_map_step_id: step_id,
        project_id: project_id,
        uid: localStorage.getItem("uid"),
        type,
      };

      var functions = firebase.functions();
      let createNode = firebase
        .functions()
        .httpsCallable("create_project_map_node");
      createNode(data)
        .then((result: any) => {
          this.curProject = data.project_id;
          const UploadIndex = this.fieldUpdate.findIndex(
            (item) => item.field_id === project_map_step_field_id
          );
          if (UploadIndex > -1) {
            let obj =
              project_map_step_field_id === "2xRks4oV4X2XHFTstXtO"
                ? {accounting_ref: inputVal}
                : this.fieldUpdate[UploadIndex].update_obj;
            this._admin.editProject(obj, project_id).then(
              (res) => {},
              (err) => {
                this._toastr.error(
                  `Something went wrong while updating projects!`,
                  "",
                  {timeOut: 4000}
                );
              }
            );
          }
          this.showDetailData(
            this.currentProjectId,
            this.currentContactId,
            true
          );
          this._common.showLoader(false);
          this._toastr.success(result.data.message, "", {timeOut: 4000});
        })
        .catch((err) => {
          this._common.showLoader(false);
          this._toastr.error(
            `${
              err && err.error && err.error.message
                ? err.error.message
                : "Something went wrong!"
            }`,
            "",
            {timeOut: 4000}
          );
        });
    }
  }

  showSaveBtn(field_type, field_id) {
    if (field_type === "string" || field_type === "select") {
      this.showField = field_id;
    }
  }

  download(url) {
    this._file.downloadFile(url).subscribe((response) => {
      let blob: any = new Blob([response.blob()], {
        type: "text/json; charset=utf-8",
      });
      // const url= window.URL.createObjectURL(blob);
      // window.open(url);
      // window.location.href = response.url;
      fileSaver.saveAs(
        blob,
        `download.${url.split("?")[0].split(".").reverse()[0]}`
      );
    }),
      (error) => console.log("Error downloading the file"),
      () => console.info("File downloaded successfully");
  }

  // open add appointment dialog
  openAddAppointmentDialog(id, contact_id) {
    this.dialog.open(AddAppointmentDialogComponent, {
      width: "auto",
      data: {
        project_id: id,
        contact_id: contact_id,
        category: "project",
      },
    });
  }

  // Add open reminder dialog
  openAddReminderDilaog(id) {
    this.dialog.open(AddReminderDialogComponent, {
      width: "auto",
      data: {
        project_id: id,
        category: "project",
      },
    });
  }

  // Add note dialog
  openAddNoteDilaog(id) {
    this.dialog.open(AddNoteDialogComponent, {
      width: "auto",
      data: {
        project_id: id,
        category: "project",
      },
    });
  }

  // OpenStepWalkThroughDialog
  openStepWalkThroughDialog(
    project_name,
    contact_first_name,
    contact_last_name,
    project_address,
    contact_id,
    project_id,
    owner_contact_id
  ) {
    this.dialog.open(ScheduleWalkThroughDialogComponent, {
      width: "auto",
      data: {
        project_name,
        contact_first_name,
        contact_last_name,
        project_address,
        contact_id,
        project_id,
        owner_contact_id,
      },
    });
  }

  // Open Request Delivery Modal
  openRequestDeliveryModal(
    project_id,
    project_data,
    step_number,
    list_iteration,
    step_id
  ) {
    this.curTab = `${list_iteration}${step_id}`;
    this.dialog.open(RequestDeliveryDialogComponent, {
      width: "auto",
      data: {
        project_id,
        accounting_ref: project_data.accounting_ref,
        contact_first_name: project_data.contact_first_name,
        contact_last_name: project_data.contact_last_name,
        project_name: project_data.name,
        step_number,
      },
    });
  }

  // Open SendToProductionModal
  openSendToProductionModal(project_id, list_iteration, step_id) {
    this.curTab = `${list_iteration}${step_id}`;
    this.dialog.open(SendToProductionDialogComponent, {
      width: "auto",
      data: {
        project_id,
      },
    });
  }

  // Request techinal designer
  requestTechicalDesigner(project_id, project_data, step_number) {
    this._admin
      .editProject(
        {
          technical_designer_requested: "Yes",
          step3_review_request_date_initiated: Date.now(),
        },
        project_id
      )
      .then(
        (res) => {
          this.subscription14 = this._lead
            .getContactDetail(project_data.owner_contact_id)
            .subscribe(
              (designer) => {
                this.subscription15 = this._project
                  .getProjectMapNode(project_id)
                  .subscribe(
                    (nodeList) => {
                      const nodes = nodeList.map((item) =>
                        item.payload.doc.data()
                      );
                      this._project.getProjectMapDriveLink(project_id).then(
                        (fileList: any) => {
                          const files = fileList.map((item) =>
                            item.payload.doc.data()
                          );
                          const requestedProductionWeekIndex = nodes.findIndex(
                            (item) =>
                              item["project_map_field_id"] ===
                              "ffOuAulZqHN3avAzbfi5"
                          );
                          const sizeIndex = nodes.findIndex(
                            (item) =>
                              item["project_map_field_id"] ===
                              "16jq0ASz1FsSP2HbRSBb"
                          );
                          const complexityIndex = nodes.findIndex(
                            (item) =>
                              item["project_map_field_id"] ===
                              "8Mwe89gcvBYNuOuurhVe"
                          );
                          const cabinetsIndex = nodes.findIndex(
                            (item) =>
                              item["project_map_field_id"] ===
                              "Aa0mO4IwJOBMq6t46EpL"
                          );
                          const appliancesIndex = files.findIndex(
                            (item) =>
                              item["project_map_field_id"] ===
                              "EZqW8QL9dwgImazd7oDp"
                          );
                          const photosIndex = files.findIndex(
                            (item) =>
                              item["project_map_field_id"] ===
                              "Wv8Acm3vQspa2zP4ireH"
                          );
                          const styleIndex = files.findIndex(
                            (item) =>
                              item["project_map_field_id"] ===
                              "xmBq40fr0zlZ00pxTJvA"
                          );
                          const walkChecklistIndex = files.findIndex(
                            (item) =>
                              item["project_map_field_id"] ===
                              "hdTkfyCa5Vc6N0KouQM0"
                          );
                          const measurementIndex = files.findIndex(
                            (item) =>
                              item["project_map_field_id"] ===
                              "S9sBI93pFQryXyV6a5xw"
                          );
                          const kpsIndex = files.findIndex(
                            (item) =>
                              item["project_map_field_id"] ===
                              "1cPSWuR2lklh6WrDV45H"
                          );
                          const updtaedDesignIndex = files.findIndex(
                            (item) =>
                              item["project_map_field_id"] ===
                              "tASShhH47wpRYFkkQbPr"
                          );

                          //Code to send email
                          const mailBody = {
                            to: "rs@leichtnewyork.com", //
                            subject: `Ref #: ${project_data.accounting_ref} - ${project_data.contact_first_name} ${project_data.contact_last_name} - ${project_data.name} - ${step_number} - TD Request`,
                            body: `Name: ${project_data.contact_first_name} ${
                              project_data.contact_last_name
                            }<br/>Designer: ${
                              designer.payload.data()["first_name"]
                            } ${
                              designer.payload.data()["last_name"]
                            } <br/> Reference: ${
                              project_data.accounting_ref
                            } <br/> Status: ${
                              project_data.status_name
                            }<br/>Requested Production Week: ${
                              nodes[requestedProductionWeekIndex]["value"]
                            }<br/> Size: ${
                              nodes[sizeIndex]["value"]
                            }<br/>Complexity:${
                              nodes[complexityIndex]["value"]
                            }<br/> Amount of Cabinets: ${
                              nodes[cabinetsIndex]["value"]
                            } <br/> Appliances Form:${
                              files[appliancesIndex]["fbs_download_url"]
                            } <br/>Site Photos: ${
                              files[photosIndex]["fbs_download_url"]
                            }<br/>Style Selection Form: ${
                              files[styleIndex]["fbs_download_url"]
                            }<br/>Walk Through Checklist: ${
                              files[walkChecklistIndex]["fbs_download_url"]
                            }<br/>Walk Through Measurements: ${
                              files[measurementIndex]["fbs_download_url"]
                            }<br/>KPS File: ${
                              files[kpsIndex]["fbs_download_url"]
                            }<br/>Updated Design: ${
                              files[updtaedDesignIndex]["fbs_download_url"]
                            }<br/>Project:${
                              environment.appUrl
                            }project/${project_id} <br/>Account: ${
                              environment.appUrl
                            }project/${
                              project_data.contact_id
                            }<br/><br/>-<br/>Automated email sent via RS `,
                            cc: `gs@gregorysmith.ws,nurit@gregorysmith.ws,helya@gregorysmith.ws,${
                              designer.payload.data()["email"]
                            }`,
                          }; //
                          this._project.initEmail(mailBody).subscribe(
                            (res) => {
                              if (res) {
                                this.showDetailData(
                                  this.currentProjectId,
                                  this.currentContactId,
                                  true
                                );
                                this._common.showLoader(false);
                                this._toastr.success(res.message, "", {
                                  timeOut: 4000,
                                });
                              }
                            },
                            (err) => {
                              this.showDetailData(
                                this.currentProjectId,
                                this.currentContactId,
                                true
                              );
                              this._common.showLoader(false);
                              this._toastr.error(
                                `${
                                  err && err.error && err.error.message
                                    ? err.error.message
                                    : "Something went wrong!"
                                }`,
                                "",
                                {timeOut: 4000}
                              );
                            }
                          );
                        },
                        (err) => {
                          this._common.showLoader(false);
                          this._toastr.error(
                            `${
                              err && err.error && err.error.message
                                ? err.error.message
                                : "Something went wrong!"
                            }`,
                            "",
                            {timeOut: 4000}
                          );
                        }
                      );
                    },
                    (err) => {
                      this._common.showLoader(false);
                      this._toastr.error(
                        `${
                          err && err.error && err.error.message
                            ? err.error.message
                            : "Something went wrong!"
                        }`,
                        "",
                        {timeOut: 4000}
                      );
                    }
                  );
              },
              (err) => {
                this._common.showLoader(false);
                this._toastr.error(
                  `${
                    err && err.error && err.error.message
                      ? err.error.message
                      : "Something went wrong!"
                  }`,
                  "",
                  {timeOut: 4000}
                );
              }
            );
        },
        (err) => {
          this._toastr.error(`Something went wrong!`, "", {timeOut: 4000});
        }
      );
  }

  // Submit information review...
  submitInformationReview(
    step_number,
    project_id,
    project_data,
    list_iteration,
    step_id
  ) {
    this.curTab = `${list_iteration}${step_id}`;
    this.curProject = project_id;
    this._common.showLoader(true);
    const status = document.getElementById(
      `${step_number}-${project_id}-status`
    )["value"];
    const text = document.getElementById(`${step_number}-${project_id}-text`)[
      "value"
    ];
    let obj;
    switch (step_number) {
      case 3:
        obj = {
          step3_review_request_state: status,
          step3_review_request_comment: text,
        };
        break;
      case 4:
        obj = {
          step4_review_request_state: status,
          step4_review_request_comment: text,
        };
        break;
      case 5:
        obj = {
          step5_review_request_state: status,
          step5_review_request_comment: text,
        };
        break;
      case 6:
        obj = {
          step6_review_request_state: status,
          step6_review_request_comment: text,
        };
        break;
      case 7.5:
        obj = {
          step7_5_review_request_state: status,
          step7_5_review_request_comment: text,
        };
        break;
      case 9:
        obj = {
          step9_review_request_state: status,
          step9_review_request_comment: text,
        };
        break;
    }

    this._admin.editProject(obj, project_id).then(
      (res) => {
        this.subscription17 = this._lead
          .getContactDetail(project_data.owner_contact_id)
          .subscribe(
            (designer) => {
              if (status === "Approved") {
                let cc;
                if (step_number === 3 || step_number === 5) {
                  cc = ``; //`gs@gregorysmith.ws,nurit@gregorysmith.ws,helya@gregorysmith.ws,${designer.payload.data()['email']}`;
                } else if (step_number === 4) {
                  cc = ``; //`natanel_gkc@gregorysmith.ws,mayan@gregorysmith.ws,processing_gkc@gregorysmith.ws,aviram_gkc@gregorysmith.ws,admin_gkc@gregorysmith.ws,helya@gregorysmith.ws,nurit@gregorysmith.ws,gs@gregorysmith.ws,${designer.payload.data()['email']}`;
                } else if (step_number === 6 || step_number === 9) {
                  cc = ``; // `nurit@gregorysmith.ws,${designer.payload.data()['email']}`;
                } else if (step_number === 11) {
                  cc = ``; //`mayan@gregorysmith.ws,helya@gregorysmith.ws,nurit@gregorysmith.ws,${designer.payload.data()['email']}`;
                }

                if (step_number === 6) {
                  const obj2 = {
                    appliance_spec_package_approved: "Yes",
                    perspectives_approved: "Yes",
                    order_confirmation_approved: "Yes",
                    installation_plans_approved: "Yes",
                  };

                  this._admin.editProject(obj2, project_id).then(
                    (res) => {},
                    (err) => {
                      this._toastr.error(
                        `Something went wrong while updating projects!`,
                        "",
                        {timeOut: 4000}
                      );
                    }
                  );
                }

                //Code to send email
                const mailBody = {
                  to: "rs@leichtnewyork.com", //
                  subject: `Ref #: ${project_data.accounting_ref} - ${project_data.contact_first_name} ${project_data.contact_last_name} - ${project_data.name} - Step ${step_number} - Approved`,
                  body: `Review approved for the below project:<br/><br/>Comment: ${text}<br/>Step: ${step_number} <br/> Name: ${
                    project_data.contact_first_name
                  } ${project_data.contact_last_name} <br/> Designer:  ${
                    designer.payload.data()["first_name"]
                  } ${designer.payload.data()["last_name"]} <br/>Reference: ${
                    project_data.accounting_ref
                  }<br/>Project:${
                    environment.appUrl
                  }project/${project_id} <br/>Account: ${
                    environment.appUrl
                  }project/${
                    project_data.contact_id
                  }<br/><br/>-<br/>Automated email sent via RS `,
                  cc: cc,
                };

                this._project.initEmail(mailBody).subscribe(
                  (res) => {
                    if (res) {
                      this._common.showLoader(false);
                      this._toastr.success("Request sent successfully!", "", {
                        timeOut: 4000,
                      });
                    }
                  },
                  (err) => {
                    this._common.showLoader(false);
                    this._toastr.error(
                      `${
                        err && err.error && err.error.message
                          ? err.error.message
                          : "Something went wrong!"
                      }`,
                      "",
                      {timeOut: 4000}
                    );
                  }
                );
              } else {
                let cc;
                if (step_number === 3 || step_number === 5) {
                  cc = `gs@gregorysmith.ws,nurit@gregorysmith.ws,helya@gregorysmith.ws,${
                    designer.payload.data()["email"]
                  }`;
                } else if (step_number === 4) {
                  cc = `nurit@gregorysmith.ws,${
                    designer.payload.data()["email"]
                  }`;
                } else if (step_number === 9 || step_number === 11) {
                  cc = `helya@gregorysmith.ws,nurit@gregorysmith.ws,${
                    designer.payload.data()["email"]
                  }`;
                }

                //Code to send email
                const mailBody = {
                  to: "rs@leichtnewyork.com", //
                  subject: `Ref #: ${project_data.accounting_ref} - ${project_data.contact_first_name} ${project_data.contact_last_name} - ${project_data.name} - Step ${step_number} - Declined`,
                  body: `Review declined for the below project:<br/><br/>Comment: ${text}<br/>Step: ${step_number} <br/> Name: ${
                    project_data.contact_first_name
                  } ${project_data.contact_last_name} <br/> Designer:  ${
                    designer.payload.data()["first_name"]
                  } ${designer.payload.data()["last_name"]} <br/>Reference: ${
                    project_data.accounting_ref
                  }<br/>Project:${
                    environment.appUrl
                  }project/${project_id} <br/>Account: ${
                    environment.appUrl
                  }project/${
                    project_data.contact_id
                  }<br/><br/>-<br/>Automated email sent via RS `,
                  cc: cc,
                };
                this._project.initEmail(mailBody).subscribe(
                  (res) => {
                    if (res) {
                      this._common.showLoader(false);
                      this._toastr.success(res.message, "", {timeOut: 4000});
                    }
                  },
                  (err) => {
                    this._common.showLoader(false);
                    this._toastr.error(
                      `${
                        err && err.error && err.error.message
                          ? err.error.message
                          : "Something went wrong!"
                      }`,
                      "",
                      {timeOut: 4000}
                    );
                  }
                );
              }

              this.showDetailData(
                this.currentProjectId,
                this.currentContactId,
                true
              );
            },
            (err) => {
              this._toastr.error(
                `Something went wrong while updating projects!`,
                "",
                {timeOut: 4000}
              );
            }
          );
      },
      (err) => {
        this._toastr.error(
          `Something went wrong while updating projects!`,
          "",
          {timeOut: 4000}
        );
      }
    );
  }

  checkStepVisibility(number, project) {
    switch (number) {
      case 2:
        return project.retainer_agreement_added == "Yes" ||
          project.purchase_agreement_cabinetry_added === "Yes"
          ? true
          : false;
      case 3:
        return project.floor_plan_added == "Yes" &&
          project.desired_production_week_added == "Yes"
          ? true
          : false;
      case 5:
        return project.step4_review_request_state === "Approved" ? true : false;
      case 6:
        return project.step5_review_request_state === "Approved" ? true : false;
      case 7:
        return project.step5_review_request_state === "Approved" &&
          project.step6_review_request_state === "Approved" &&
          project.mechanical_plan_added === "Yes" &&
          project.sent_to_production === "Yes" &&
          project.installation_plans_approved === "Yes" &&
          project.order_confirmation_approved === "Yes" &&
          project.perspectives_approved === "Yes" &&
          project.appliance_spec_package_approved === "Yes"
          ? true
          : false;
      case 7.5:
        return project.delivery_requested === "Yes" ? true : false;
      case 10:
        return project.step9_review_request_state === "Approved" ? true : false;

      default:
        return true;
    }
  }

  openFileListDialog(field_id, project_id) {
    this.dialog.open(ProjectMapFilesDialogComponent, {
      width: "auto",
      data: {
        field_id: field_id,
        project_id: project_id,
      },
    });
  }

  requestApprovalBtn(project_data, contactData) {
    this._common.showLoader(true);
    //Code to send email
    const mailBody = {
      to: "rs@leichtnewyork.com", //
      subject: `Ref #: ${project_data.payload.doc.data().accounting_ref} - ${
        project_data.payload.doc.data().contact_first_name
      } ${project_data.payload.doc.data().contact_last_name} - ${
        project_data.payload.doc.data().name
      } - Step 6 - Installation Plans - Approval Request`,
      body: `Review requested for: Installation Plans<br/><br/>Step: 6<br/> Name: ${
        project_data.payload.doc.data().contact_first_name
      } ${project_data.payload.doc.data().contact_last_name} <br/> Designer:  ${
        project_data.payload.doc.data().owner_first_name
      } ${project_data.payload.doc.data().contact_last_name} <br/>Reference: ${
        project_data.payload.doc.data().accounting_ref
      }<br/>Account: ${environment.appUrl}project/${
        project_data.payload.doc.data().contact_id
      }<br/>Project:${environment.appUrl}project/${
        project_data.payload.doc.data().id
      } <br/><br/>-<br/>Automated email sent via RS `,
      cc: `nurit@gregorysmith.ws,helya@gregorysmith.ws,${contactData.email}`,
    };
    this._project.initEmail(mailBody).subscribe(
      (res) => {
        if (res) {
          this._common.showLoader(false);
          this._toastr.success(res.message, "", {timeOut: 4000});
        }
      },
      (err) => {
        this._common.showLoader(false);
        this._toastr.error(
          `${
            err && err.error && err.error.message
              ? err.error.message
              : "Something went wrong!"
          }`,
          "",
          {timeOut: 4000}
        );
      }
    );
  }

  createTab(project_id, name) {
    this._common.showLoader(true);
    // Check if the current contact is already saved for this user id
    // this._admin.checkContactTab(project_id, localStorage.getItem('uid')).subscribe(resp=>{
    // if(resp.length==0){
    const obj = {
      id: project_id,
      project_id: project_id,
      project_name: name,
      author_contact_id: localStorage.getItem("contactId"),
      author_user_id: localStorage.getItem("uid"),
      date_created: Date.now(),
    };

    this._admin
      .createContactTab(project_id, obj)
      .then((res2) => {
        this._common.showLoader(false);
        this._toastr.success(`Tab created successfully!`, "", {timeOut: 4000});
      })
      .catch((err) => {
        this._common.showLoader(false);
        this._toastr.error(`Something went wrong!`, "", {timeOut: 4000});
      });
    // }
    // },err=>{
    //   this._common.showLoader(false);
    //   this._toastr.error(`Something went wrong!`,"",{ timeOut: 4000 });
    // })
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscription2) this.subscription2.unsubscribe();
    if (this.subscription3) this.subscription3.unsubscribe();
    if (this.subscription4) this.subscription4.unsubscribe();
    if (this.subscription5) this.subscription5.unsubscribe();
    if (this.subscription6) this.subscription6.unsubscribe();
    if (this.subscription7) this.subscription7.unsubscribe();
    if (this.subscription8) this.subscription8.unsubscribe();
    if (this.subscription9) this.subscription9.unsubscribe();
    if (this.subscription10) this.subscription10.unsubscribe();
    if (this.subscription11) this.subscription11.unsubscribe();
    if (this.subscription12) this.subscription12.unsubscribe();
    if (this.subscription13) this.subscription13.unsubscribe();
    if (this.subscription14) this.subscription14.unsubscribe();
    if (this.subscription15) this.subscription15.unsubscribe();
    // if(this.subscription16) this.subscription15.unsubscribe();
    if (this.subscription17) this.subscription15.unsubscribe();
  }
}
